import { useContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import { AuthContext } from '@/contexts/AuthContext';
import { PageLoader } from '@/components/Common/PageLoader/PageLoader';
import { TermsOfServiceDialog } from '@/components/Authentication/TermsOfServiceDialog';
import { getCookie, ONE_YEAR_SECONDS, setCookie } from '@/services/cookiesService';
import { posthog } from '@/providers/posthog';

export const IDP_INITIATED_REDIRECT_PATH = 'idp_initiated_redirect_path';

const TERMS_OF_SERVICE_ACCEPTED_COOKIE = 'weavy_tos_accepted';

const isTermsOfServiceAccepted = () => getCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE) === 'true';
const setTermsOfServiceAccepted = () =>
  setCookie(TERMS_OF_SERVICE_ACCEPTED_COOKIE, 'true', { maxAge: ONE_YEAR_SECONDS });

export function IdpInitiatedSignInPage() {
  const { initiateRedirectSignIn, signOut } = useContext(AuthContext);
  const [searchParams] = useSearchParams();
  const [showTermsOfService, setShowTermsOfService] = useState(false);

  const proceedToOAuth = () => signOut().then(() => initiateRedirectSignIn('figma', '/signin'));

  useEffect(() => {
    const redirectPath = searchParams.get('redirect_path') ?? '/';
    if (redirectPath) {
      sessionStorage.setItem(IDP_INITIATED_REDIRECT_PATH, redirectPath);
    } else {
      sessionStorage.removeItem(IDP_INITIATED_REDIRECT_PATH);
    }

    const tosAlreadyAccepted = isTermsOfServiceAccepted();
    const promotion = searchParams.get('promotion');

    if (promotion) {
      posthog.capture('figma_promo_idp_landed', {
        promotion,
        fuid: searchParams.get('fuid'),
        figma_anon_id: searchParams.get('figma_anon_id'),
        utm_source: searchParams.get('utm_source'),
        utm_medium: searchParams.get('utm_medium'),
        utm_campaign: searchParams.get('utm_campaign'),
        utm_term: searchParams.get('utm_term'),
        redirect_path: redirectPath,
        tos_already_accepted: tosAlreadyAccepted,
      });
    }

    if (tosAlreadyAccepted) {
      void proceedToOAuth();
    } else {
      if (promotion) posthog.capture('figma_promo_tos_shown');
      setShowTermsOfService(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [initiateRedirectSignIn, searchParams, signOut]);

  const handleTermsOfServiceAccept = () => {
    if (searchParams.get('promotion')) {
      posthog.capture('figma_promo_tos_accepted');
    }
    setTermsOfServiceAccepted();
    setShowTermsOfService(false);
    void proceedToOAuth();
  };

  if (showTermsOfService) {
    return <TermsOfServiceDialog onAccept={handleTermsOfServiceAccept} />;
  }

  return <PageLoader />;
}
